<template>
    <div class="channels-insights" v-if="!excludeBots.includes($store.state.bot.botId)">
        <div class="card-curvey">
            <v-layout>
                <v-flex xs7>
                    <v-autocomplete
                           no-data-text="no channels"
                            :items="channels"
                            item-text="name"
                            item-value="name"
                            v-model="selectedChannels"
                            return-object
                            outline
                            solo
                            multiple
                            class="white-input"
                    >
                        <template v-slot:selection="data">
                            <v-chip
                                    :selected="data.selected"
                                    close
                                    @input="removeChannel(data.item)"
                            >
                                <v-avatar>
                                    <img  :src="require(`../../assets/img/social/${getImageName(data.item.name)}`)" alt="" height="10px">
                                </v-avatar>
                                <strong>{{ data.item.name }}</strong>&nbsp;
                            </v-chip>
                        </template>
                    </v-autocomplete>
                </v-flex>
                <v-flex xs5 class="text-sm-right">
                    <date-range-picker opens="left" :max-date="new Date()" v-model="dateRange" @update="updateDate"></date-range-picker>
                    <v-btn @click="clearDates" round color="primary" style="height: 34px">Clear</v-btn>
                </v-flex>
            </v-layout>
            <v-layout row wrap >
                <v-flex md12 class="pa-5">
                    <sessions-per-date v-if="selectedChannels" :channels="selectedChannels"></sessions-per-date>
                </v-flex>
                <v-flex md4 class="pa-5">
                    <total-sessions v-if="selectedChannels" :channels="selectedChannels"></total-sessions>
                </v-flex>
                <v-flex md8 class="pa-5">
                    <avg-time-session v-if="selectedChannels" :channels="selectedChannels"></avg-time-session>
                </v-flex>
            </v-layout>
        </div>
        <div class="card-curvey">
            <v-layout row wrap class="mt-5">
                <v-flex md6 class="pa-5">
                    <avg-meg-per-session v-if="selectedChannels" :channels="selectedChannels"></avg-meg-per-session>
                </v-flex>
                <v-flex md6 class="pa-5">
                    <msg-per-channels v-if="selectedChannels" :channels="selectedChannels"></msg-per-channels>
                </v-flex>
                <v-flex md4 class="pa-1">
                    <avg-total-msg-per-session v-if="renderCheck"  :total-data="totalData"></avg-total-msg-per-session>
                </v-flex>
                <v-flex md4 class="pa-1">
                    <total-msg v-if="selectedChannels" :channels="selectedChannels"></total-msg>
                </v-flex>
                <v-flex md4 class="pa-1">
                    <total-msg-type v-if="renderCheck"  :total-data="totalData"></total-msg-type>
                </v-flex>
            </v-layout>
        </div>
    </div>
</template>

<script>
    import common from "../../utils/common";
    import sessionsPerDate from './sessions-per-date'
    import totalSessions from './total-sessions'
    import avgMegPerSession from './avg-messages-per-session'
    import msgPerChannels from './messages-per-channel'
    import totalMsg from './total-messages'
    import totalMsgType from './total-messages-type'
    import avgTimeSession from './avg-time-sesssion'
    import avgTotalMsgPerSession from './avg-total-messages-per-session'
    import DateRangePicker from 'vue2-daterange-picker'
    //you need to import the CSS manually (in case you want to override it)
    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
    export default {
        name: "channels",
        components: {
            sessionsPerDate,
            totalSessions,
            avgMegPerSession,
            msgPerChannels,
            totalMsg,
            totalMsgType,
            avgTimeSession,
            avgTotalMsgPerSession,
            DateRangePicker
        },
        data() {
            return {
                renderCheck : false,
                excludeBots: ['1ilb9u1o1c83wyplf5','p2r5lojls3k1v5on1ra48','8m4UcwyAOFfORIypaKbR','08lho0hndpb7g50dqzbbq4j'],
                channels: [],
                totalData: {},
                selectedChannels: [],
                dateRange: {
                    startDate: null,
                    endDate: null
                },
                dummy: {
                    name: "facebook",
                    data: {
                        sessions: {
                            count_per_date: [
                                {
                                    count: 4,
                                    date: "2019-08-26T00:00:00Z"
                                },
                                {
                                    count: 7,
                                    date: "2019-08-28T00:00:00Z"
                                },
                                {
                                    count: 7,
                                    date: "2019-08-30T00:00:00Z"
                                }
                            ],
                            total: 1
                        },
                        avg_messages: 0,
                        avg_bot_msgs: 0,
                        avg_user_msgs: 0,
                        avg_time_per_sessions: 135,
                        total_messages: 0,
                        total_bot_msgs: 0,
                        total_user_msgs: 0
                    }
                }
            }
        },
        mounted() {
            this.getSessions()
        },
        methods: {
            getSessions() {
                this.$http_bot.get('analytics/all')
                    .then(response=>{

                        for (let i=0;i<response.data.data.channels.length;i++) {
                            if (response.data.data.channels[i].name) {
                                this.channels.push(response.data.data.channels[i])
                            }
                        }
                        this.totalData = {
                            botMsg: response.data.data.bot_messages,
                            userMsg: response.data.data.user_messages,
                            avgBotMsg: response.data.data.avg_bot_messages,
                            avgUserMsg: response.data.data.avg_user_messages
                        }
                        // this.channels.push(this.dummy)
                        this.setSelectedChannels();
                        this.renderCheck = true;
                    })
                    .catch(error=>{
                        if (error.response.status === 401) {
                            common.logOut()
                        }
                    })
            },
            setSelectedChannels() {
                this.selectedChannels = []
                for (let i=0; i<this.channels.length; i++) {
                    this.selectedChannels.push(this.channels[i])
                }
                console.log(this.selectedChannels, ' this.selectedChannels')

            },
            clearDates() {
                this.dateRange= {
                    startDate: '',
                        endDate: ''
                }
                this.selectedChannels = []
                this.channels = []
                this.getSessions()
            },
            updateDate(e) {
                this.$http_bot.get(`analytics/all?from=${common.formatDateTime(this.dateRange.startDate)}&&to=${common.formatDateTime(this.dateRange.endDate)}`)
                    .then(response=>{
                        this.channels = []
                        this.selectedChannels = []
                        if(response.data.data.channels){
                            for (let i=0;i<response.data.data.channels.length;i++) {
                                if (response.data.data.channels[i].name) {
                                    this.channels.push(response.data.data.channels[i])
                                }
                            }
                        }

                        let holder = {
                            botMsg: response.data.data.bot_messages,
                            userMsg: response.data.data.user_messages,
                            avgBotMsg: response.data.data.avg_bot_messages,
                            avgUserMsg: response.data.data.avg_user_messages
                        }
                        this.totalData = {
                            botMsg: response.data.data.bot_messages,
                            userMsg: response.data.data.user_messages,
                            avgBotMsg: response.data.data.avg_bot_messages,
                            avgUserMsg: response.data.data.avg_user_messages
                        }
                        // this.channels.push(this.dummy)
                        console.log(response, ' responseeeee')

                        console.log(this.totalData, ' this.totalData')
                        this.setSelectedChannels()
                    })
                    .catch(error=>{
                        // if (error.response.status === 401) {
                        //     common.logOut()
                        // }
                        console.log(error)
                    })
            },
            removeChannel(item) {

            },
            getImageName(name) {
                const images= ['facebook','whats','slack','skype']
                let image = images.includes(name)
                if (image) {
                    return `${name}.png`
                } else {
                    return  'web.jpg'
                }
            }
        }
    }
</script>

<style >
    .apexcharts-toolbar {
        z-index: 1;
    }
    .daterangepicker.show-calendar .ranges {
        display: none;
    }
    .vue-daterange-picker .dropdown-menu{
        padding: 0;
        width: 200px !important;
        min-width: 493px !important;
    }
    .reportrange-text[data-v-b82a64b0] {
        background: #fff;
        cursor: pointer;
        padding: 5px 10px;
        border: 1px solid #eee;
        height: 53px;
        border-radius: 20px;
        width: 225px;
        display: flex;
        align-items: center;
    }
    .daterangepicker .drp-buttons .btn {
        margin-left: 8px;
        font-size: 15px;
        font-weight: bold;
        padding: 4px 8px;
    }
</style>
